import './ShareModal.css';
import {
    WhatsappShareButton,
    FacebookShareButton,
    TwitterShareButton,
    WhatsappIcon,
    FacebookIcon,
    TwitterIcon,
} from "react-share";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { MdContentCopy } from "react-icons/md";

const ShareModal = ({ isOpen, onClose, shareUrl, title }) => {
    const [copied, setCopied] = useState(false);

    if (!isOpen) return null;

    const handleCopy = (event) => {
        event.preventDefault();
        event.stopPropagation();

        navigator.clipboard.writeText(shareUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };


    return (
        <div className="share-modal-overlay">
            <div className="share-modal-content">
                <h3>Share This Event</h3>

                <div className="share-buttons">
                    <WhatsappShareButton url={shareUrl} title={title}>
                        <WhatsappIcon size={40} round />
                    </WhatsappShareButton>

                    <FacebookShareButton url={shareUrl} quote={title}>
                        <FacebookIcon size={40} round />
                    </FacebookShareButton>

                    <TwitterShareButton url={shareUrl} title={title}>
                        <TwitterIcon size={40} round />
                    </TwitterShareButton>
                </div>

                <div className="copy-url-box">
                    <input
                        type="text"
                        value={shareUrl}
                        readOnly
                        className="copy-url-input"
                    />
                    <button onClick={(event) => handleCopy(event)} className="copy-url-btn">
                        <MdContentCopy size={25} />
                    </button>

                </div>

                <button className="share-close-btn" onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onClose();
                }}
                >
                    <IoClose size={25} />
                </button>
                <span className='event-share-copy-message'>{copied && "Copied!"}</span>
            </div>
        </div>
    );
};

export default ShareModal;
